export const toggleModal = (modalName, modalData) => ({
    type: 'TOGGLE_MODAL',
    payload: { modalName: modalName, modalData: modalData }
});

export const closeModal = () => ({
    type: 'CLOSE_MODAL',
});
